import {
    Button,
    Input
} from "antd";

import {
    SendOutlined
} from "@ant-design/icons";

const { TextArea } =
    Input;

export default function ConversationComposer({

                                                 value,

                                                 onChange,

                                                 onSend,

                                                 loading
                                             }) {

    return (

        <div>

            <TextArea

                rows={4}

                value={value}

                onChange={onChange}

                placeholder="Rédigez votre message..."
            />

            <Button

                type="primary"

                icon={
                    <SendOutlined />
                }

                style={{
                    marginTop: 12
                }}

                loading={loading}

                onClick={onSend}
            >
                Envoyer
            </Button>

        </div>
    );
}